import { TextField } from '@mui/material';

interface EmbeddingEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function EmbeddingEndpointField({
  value,
  error,
  setValue,
}: EmbeddingEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Embedding Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default EmbeddingEndpointField;

